// extracted by mini-css-extract-plugin
export default {"blacklisting":"blacklist_blacklisting__DhUIJ","textScope":"blacklist_textScope__lhve3","containerBtn":"blacklist_containerBtn__WmmHR"};